import * as types from '../constants/actionTypes';
import initialState from './initialState';
import Immutable from 'seamless-immutable';
import { PAGING_DEFAULT } from '../constants/constants';
import { MEDIA_TYPE } from '../models/recentlySentPhotoModel';
import { UPDATE_INTERNET_STATUS, TOGGLE_CREATE_PASSWORD_MODAL, SET_TIME_DURATION_SELECTION_VALUE } from '../constants/actionTypes';
// import {NotificationModal} from "../../app/web/modules";
// import React from "react";

export default function commonStateReducer(state = initialState.commonState, action) {
  switch (action.type) {
    case types.SHOW_REPORT_V2: {
      return state.set('isShowReportV2Modal', !!action.data).set('reportV2Data', action.data);
    }
    case types.HIDE_REPORT_V2: {
      return state.set('isShowReportV2Modal', false);
    }
    case types.CLEAR_REPORT_V2_DATA: {
      return state.set('reportV2Data', null);
    }
    case types.UPDATE_MESSAGE_NOTIFICATION_ERROR: {
      return state.setIn(['messageNotificationError'], action.data.toString());
    }
    case types.UPDATE_UNAVAILABLE_MESSENGER: {
      return state.set('isShownMessengerUnavailable', !!action.data);
    }
    case types.UPDATE_UNAVAILABLE_CHATROOM: {
      return state.set('isShownChatroomUnavailable', !!action.data);
    }
    case types.SELECT_PREVIEW_PHOTO: {
      return state.set('selectPhotoPreview', action.data).set('previewDataSet', action.dataSet);
    }
    case types.UPDATE_ERROR_API: {
      return state.setIn(['isErrorAPI'], true);
    }
    case types.UPDATE_DATA_CONFIRM_MODAL: {
      const { confirmModal } = Immutable.asMutable(state);

      return state.merge({
        confirmModal: {
          ...confirmModal,
          ...action.params,
        },
      });
    }
    case types.SHOW_CONFIRM_MODAL: {
      const {
        confirmModal: { onOkAction, onCancelAction, noClearCancelAction, callbackRunAnimation, noClearCallbackRunAnimation },
      } = Immutable.asMutable(state);
      let onCancel = null;
      if (action.data) {
        onCancel = action.data.onCancelAction;
      } else if (noClearCancelAction) {
        onCancel = onCancelAction;
      }
      let callbackRun = null;
      if (action.data) {
        callbackRun = action.data.callbackRunAnimation;
      } else if (noClearCallbackRunAnimation) {
        callbackRun = callbackRunAnimation;
      }
      return state.merge({
        confirmModal: {
          messageConfirm: action.data ? action.data.messageConfirm : null,
          extraFooter: action.data ? action.data.extraFooter : null,
          messageConfirmExternal: action.data && action.data.messageConfirmExternal ? action.data.messageConfirmExternal : null,
          messageConfirmExternal2: action.data && action.data.messageConfirmExternal2 ? action.data.messageConfirmExternal2 : null,
          onOkAction: action.data ? action.data.onOkAction : onOkAction,
          onCancelAction: onCancel,
          okText: action.data ? action.data.okText : '',
          cancelText: action.data ? action.data.cancelText : '',
          customClassButton: action.data ? action.data.customClassButton : null,
          customClassOk: action.data ? action.data.customClassOk : null,
          customClassCancle: action.data ? action.data.customClassCancle : null,
          headerText: action.data ? action.data.headerText : '',
          classNames: action.data ? action.data.classNames : undefined,
          disableCancel: action.data && action.data.disableCancel ? action.data.disableCancel : false,
          disableClickOverlay: action.data && action.data.disableClickOverlay ? action.data.disableClickOverlay : false,
          wrapperPosition: action.data ? action.data.wrapperPosition : 0,
          noClearCancelAction: action.data && action.data.noClearCancelAction ? action.data.noClearCancelAction : false,
          callbackRunAnimation: callbackRun,
          noClearCallbackRunAnimation: action.data ? action.data.noClearCallbackRunAnimation : false,
          keepModalWhenClickCancel: action.data ? action.data.keepModalWhenClickCancel : false,
          isMoreEndGroupChat: action.data ? action.data.isMoreEndGroupChat : false,
          disableEscClose: action.data ? action.data.disableEscClose : false,
          disableBackBrowserCloseModal: action.data ? action.data.disableBackBrowserCloseModal : false,
          isBottomModal: action.data ? action.data.isBottomModal : false,
          isOptionModal: action.data ? action.data.isOptionModal : false,
          customZIndex: action.data ? action.data.customZIndex : 40,
          customOverlayClassName: action.data ? action.data.customOverlayClassName : '',
          isOverlayBlack: action.data ? action.data.isOverlayBlack : false,
          isOverlayGray: action.data ? action.data.isOverlayGray : false,
        },
      });
    }
    case types.RESET_DATA_IN_APP_NOTIFICATION: {
      return state.set('inAppNotificationData', {});
    }
    case types.UPDATE_COMMON_STATE_REDUCER: {
      //  console.log('action.data', action)
      return state.merge({ ...state, ...action.data });
      // return state.setIn([...action.data.dataKey], action.data.dataValue);
    }
    case types.SHOW_NOTIFICATION_PHOTO_LIKE_MODAL: {
      return state.set('isShowNotificationPhotoLikeModal', true);
    }
    case types.HIDE_NOTIFICATION_PHOTO_LIKE_MODAL: {
      return state.set('isShowNotificationPhotoLikeModal', false);
    }
    case types.TOGGLE_NOTIFICATION_GROUP_JOIN_REQUEST: {
      return state.set('isShowNotificationGroupJoinRequestModal', action.data);
    }
    case types.TOGGLE_NOTIFICATION_INVITATION: {
      return state.set('isShowNotificationInvitationModal', action.data.toggle).set('invitationType', action.data.type);
    }
    case types.TOGGLE_NOTIFICATION_GROUP_ACTIVITY: {
      return state.set('isShowNotificationGroupActivityModal', action.data);
    }
    case types.TOGGLE_NOTIFICATION_GROUP_JOINS: {
      return state.set('isShowNotificationGroupJoins', action.data);
    }
    case types.SHOW_NOTIFICATION_USER_INTEREST_MODAL: {
      return state.set('isShowNotificationUserInterestModal', true);
    }
    case types.HIDE_NOTIFICATION_USER_INTEREST_MODAL: {
      return state.set('isShowNotificationUserInterestModal', false);
    }
    case types.UPDATE_STATE_COMMON_STATE: {
      state = state.setIn([...action.dataKey], action.data);
      return state;
    }
    case types.TOGGLE_IN_APP_NOTIFICATION: {
      return state.merge({
        ...state,
        isShowInAppNotification: action.data === true,
      });
    }
    case types.UPDATE_DATA_IN_APP_NOTIFICATION: {
      return state.merge({ ...state, inAppNotificationData: action.data });
    }

    case types.SUPPORT_NOTIFICATION_MANAGER: {
      return state.set('isSupportNotificationManager', action.data);
    }

    case types.SET_IS_DESKTOP: {
      return state.set('isDesktop', action.data);
    }

    case types.ADD_IN_APP_NOTIFICATION_TO_MANAGER: {
      const inAppNotificationsManagerData = [...state.inAppNotificationsManagerData];
      inAppNotificationsManagerData.push(action.data);
      // console.log("inAppNotificationsManagerData", inAppNotificationsManagerData);
      return state.set('inAppNotificationsManagerData', inAppNotificationsManagerData);
    }

    case types.REMOVE_IN_APP_NOTIFICATION_FROM_MANAGER: {
      let inAppNotificationsManagerData = [...state.inAppNotificationsManagerData];
      inAppNotificationsManagerData = inAppNotificationsManagerData.filter(inApp => {
        return inApp.keyUnique !== action.data;
      });
      return state.set('inAppNotificationsManagerData', inAppNotificationsManagerData);
    }

    case types.UPDATE_MENU_SELECTED: {
      const objUpdate = {
        menuIsSeleted: action.data.menu || '',
        subMenuIsSeleted: action.data.subMenu || '',
      };
      return state.merge({ ...objUpdate });
    }
    case types.TOGGLE_SENSITIVE_MODAL: {
      state = state.setIn(['isShowSensitive'], action.data);
      if (action.params) {
        state = state.setIn(['sensitiveContent'], action.params);
      } else {
        state = state.setIn(['sensitiveContent'], { content: null, okText: '', cancelText: '', cancelAction: null });
      }
      return state;
    }
    case types.APP_IN_BACKGROUND_TIME: {
      return state.setIn(['timeInBackground'], action.date);
    }

    // About RHP
    case types.GET_ABOUT_RHP_REQUEST: {
      return state.set('gettingAboutRhpData', true);
    }
    case types.GET_ABOUT_RHP_SUCCESS: {
      return state.set('gettingAboutRhpData', false).set('aboutRhpData', action.data);
    }
    case types.GET_ABOUT_RHP_FAILED: {
      return state.set('gettingAboutRhpData', false).set('aboutRhpData', []);
    }

    case types.GET_SEARCH_FRIEND_ONLINE_REQUEST: {
      return state.setIn(['activeModalData', 'friends', 'loading'], true);
    }

    case types.GET_SEARCH_FAVOURITES_ONLINE_REQUEST: {
      return state.setIn(['activeModalData', 'favorites', 'loading'], true);
    }

    case types.GET_SEARCH_FRIEND_ONLINE_SUCCESS: {
      const page = action.params && action.params.page > 1 ? action.params.page : 1;
      const data = page > 1 ? [...state.activeModalData.friends.data, ...action.data] : action.data;
      const size = action.params && action.params.size ? action.params.size : 20;
      const isHasMoreData = action.data.length >= size;
      return state
        .setIn(['activeModalData', 'friends', 'loading'], false)
        .setIn(['activeModalData', 'friends', 'data'], data)
        .setIn(['activeModalData', 'friends', 'isHasMoreData'], isHasMoreData)
        .setIn(['activeModalData', 'friends', 'page'], page);
    }

    case types.GET_SEARCH_FAVOURITES_ONLINE_SUCCESS: {
      const page = action.params && action.params.page > 1 ? action.params.page : 1;
      const data = page > 1 ? [...state.activeModalData.favorites.data, ...action.data] : action.data;
      const size = action.params && action.params.size ? action.params.size : 20;
      const isHasMoreData = action.data.length >= size;
      return state
        .setIn(['activeModalData', 'favorites', 'loading'], false)
        .setIn(['activeModalData', 'favorites', 'data'], data)
        .setIn(['activeModalData', 'favorites', 'isHasMoreData'], isHasMoreData)
        .setIn(['activeModalData', 'favorites', 'page'], page);
    }

    case types.GET_SEARCH_FRIEND_ONLINE_FAILED: {
      return state.setIn(['activeModalData', 'friends', 'loading'], false);
    }

    case types.GET_SEARCH_FAVOURITES_ONLINE_FAILED: {
      return state.setIn(['activeModalData', 'favorites', 'loading'], false);
    }
    case types.MODAL_AUTHENTICATE: {
      return state.setIn(['isOpenModalAuthenticate'], action.status);
    }
    case types.TOGGLE_RECENTLY_SENT_PHOTO: {
      return state.set('isUsingPreviewPhotoToSendImage', action.isSending).setIn(['isShowRecentlySentPhotos'], action.data);
    }
    case types.TOGGLE_SET_MESSAGE_IMAGE_DURATION_MODAL: {
      return state
        .setIn(['isShowSetMessageImageDurationModal'], action.data.toggle)
        .setIn(['canSetDefaultValueImageDurationModal'], action.data.canSetDefaultValue);
    }
    case types.SET_TIME_DURATION_SELECTION_VALUE: {
      return state.set('imageDurationSelectionValue', action.data);
    }
    case types.GET_USER_SHARED_PHOTOS_SUCCESS: {
      const { params, data, paginationInfo } = action.data;

      return state.setIn(['userSharedPhotos'], {
        data: params.page === 1 ? data : [...state.userSharedPhotos.data, ...data],
        page: params.page,
        size: params.size || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
        isHasMore: data.length === (params.size || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH),
        paginationInfo,
      });
    }
    case types.PATCH_USER_SHARED_VIDEOS_SUCCESS: {
      const {
        userSharedPhotos: {
          paginationInfo: { totalItems },
        },
      } = Immutable.asMutable(state);

      return state.setIn(['userSharedPhotos', 'paginationInfo', 'totalItems'], totalItems - action?.data?.length).setIn(
        ['userSharedPhotos', 'data'],
        state.userSharedPhotos.data.filter(itm => (itm.mediaType === MEDIA_TYPE.VIDEO ? !action.data.includes(itm.data.videoId) : true))
      );
    }
    case types.PATCH_USER_SHARED_PHOTOS_SUCCESS: {
      const {
        userSharedPhotos: {
          paginationInfo: { totalItems },
        },
      } = Immutable.asMutable(state);
      return state.setIn(['userSharedPhotos', 'paginationInfo', 'totalItems'], totalItems - action?.data?.length).setIn(
        ['userSharedPhotos', 'data'],
        state.userSharedPhotos.data.filter(itm => (itm.mediaType === MEDIA_TYPE.PHOTO ? !action.data.includes(itm.data.photoId) : true))
      );
    }

    case types.ADD_USER_MEDIA_SUCCESS: {
      const {
        userSharedPhotos: {
          paginationInfo: { totalItems },
        },
      } = Immutable.asMutable(state);
      if (!action.data || !Array.isArray(action.data)) {
        return state;
      }
      return state
        .setIn(['userSharedPhotos', 'data'], [...action.data, ...state.userSharedPhotos.data])
        .setIn(['userSharedPhotos', 'paginationInfo', 'totalItems'], totalItems + action.data.length);
    }

    case types.UPDATE_METRICS_STATUS: {
      return state.merge({
        metricsStatus: action.status,
      });
    }

    case types.TOGGLE_SHARE_URL_MODAL:
      return state
        .setIn(['isShowShareUrlModal'], action.data?.toggle)
        .setIn(['seoURL'], action.data?.seoURL || null)
        .setIn(['titleHeader'], action.data?.titleHeader || '');
    case types.UPDATE_WINDOW_DIMENSIONS:
      return state.set('windowDimensions', action.data);
    case types.UPDATE_CHAT_SYSTEM_DOWN_MODAL_STATUS:
      return state.setIn(['chatSystemDownModalShow'], action.data);
    case types.USER_LOGOUT_SUCCESS:
      return state.merge({
        ...initialState.commonState,
      });
    case types.UPDATE_DATA_SPOTLIGHT_SUCCESS:
      const { dataSpotlightModal } = Immutable.asMutable(state);
      if (dataSpotlightModal.length > 0) {
        const { userId, params } = action;
        const index = dataSpotlightModal.findIndex(item => item.detail.userId === userId);
        const user = dataSpotlightModal[index];
        state = state.setIn(['dataSpotlightModal', index], { ...user, ...params });
      }
      return state;

    case types.TOGGLE_CREATE_PASSWORD_MODAL: {
      const newState = {
        createNewPassWordModal: {
          isShowModal: action.data.isShowModal,
          callbackCreatePasswordSuccess: action.data.callbackCreatePasswordSuccess,
          callbackCreatePasswordFailed: action.data.callbackCreatePasswordFailed,
          description: action.data.des,
        },
      };
      return state.merge({ ...newState });
    }

    case types.TOGGLE_VERIFY_PASSWORD_MODAL: {
      const newState = {
        verifyPasswordModal: {
          isShowModal: action.data.isShowModal,
          callbackVerifyPasswordSuccess: action.data.callbackVerifyPasswordSuccess,
          description: action.data.des,
        },
      };
      return state.merge({ ...newState });
    }
    case types.TOGGLE_MY_GROUPS_MODAL: {
      return state.set('isShowMyGroupsModal', action.data);
    }
    case types.TOGGLE_JOINED_GROUPS_MODAL: {
      return state.set('isShowJoinedGroupsModal', action.data);
    }
    case types.TOGGLE_GROUP_MEMBER_MODAL: {
      return state.set('metadataGroupMemberModal', action.data);
    }
    case types.TOGGLE_GLOBAL_PREVIEW_MEDIA_MODAL: {
      return state.set('metadataGlobalPreviewMediaModal', action.data);
    }
    case types.TOGGLE_DISABLE_RECONNECTING_LABEL: {
      return state.merge({ disableReconnectingLabel: action.disableReconnectingLabel });
    }
    default:
      return state;
  }
}
